import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.vue?vue&type=style&index=0&id=60aecdeb&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60aecdeb"]])

export default __exports__